import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { API } from "../../api/types";

export interface ResultState {
  isLoading: boolean;
  tabSelectedIndex: number;
  advices?: API.ResultAdvicesModel;
  predictId?: number;
}

const initialState: ResultState = {
  isLoading: false,
  tabSelectedIndex: 0,
};

export const resultSlice = createSlice({
  name: "result",
  initialState,
  reducers: {
    // STATE
    setTabSelectedIndex: (
      state: ResultState,
      action: PayloadAction<number>
    ) => {
      state.tabSelectedIndex += action.payload;
    },
    setAdvices: (
      state: ResultState,
      action: PayloadAction<API.ResultAdvicesModel>
    ) => {
      state.advices = action.payload;
    },
    setPredictId: (state: ResultState, action: PayloadAction<number>) => {
      state.predictId = action.payload;
    },

    // API
    readAdvices: (
      state: ResultState,
      action: PayloadAction<API.ReadAdvicesRequest>
    ) => {
      state.isLoading = true;
    },
    readAdvicesDone: (state: ResultState) => {
      state.isLoading = false;
    },
    createReaction: (
      state: ResultState,
      action: PayloadAction<API.CreateReactionRequest>
    ) => {
      state.isLoading = true;
    },
    createReactionDone: (state: ResultState) => {
      state.isLoading = false;
    },
  },
});

//=========== ACTION ==========
export const actResult = resultSlice.actions;

//=========== SELECTOR ==========
export const slResult = (state: RootState) => state.result;

//=========== REDUCER ==========
const resultReducer = resultSlice.reducer;
export default resultReducer;
